import { baseApi } from '../../../core/baseApi';
import { unwrapApiResponse } from '../../../patterns/crud';
import type { Schema } from '@voley/shared-types';

// Response types — derived from OpenAPI schemas (SSOT)
export type ZapierConnectResponse = Schema<'ZapierConnectResponse'>;
export type ZapierStatusResponse = Schema<'ZapierStatusResponse'>;

export const zapierApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    generateZapierKey: builder.mutation<ZapierConnectResponse, void>({
      query: () => ({
        url: '/integrations/zapier/credentials/generate',
        method: 'POST',
      }),
      transformResponse: unwrapApiResponse,
      invalidatesTags: ['IntegrationsStatus'],
    }),

    getZapierKeyStatus: builder.query<ZapierStatusResponse, void>({
      query: () => '/integrations/zapier/credentials/status',
      transformResponse: unwrapApiResponse,
      providesTags: ['IntegrationsStatus'],
    }),

    revokeZapierKey: builder.mutation<{ message: string }, void>({
      query: () => ({
        url: '/integrations/zapier/credentials',
        method: 'DELETE',
      }),
      transformResponse: unwrapApiResponse,
      invalidatesTags: ['IntegrationsStatus'],
    }),
  }),
});

export const {
  useGenerateZapierKeyMutation,
  useGetZapierKeyStatusQuery,
  useRevokeZapierKeyMutation,
} = zapierApi;
